import { render, staticRenderFns } from "./DocumentsDisplayToolbar.vue?vue&type=template&id=e2d91b0a&"
import script from "./DocumentsDisplayToolbar.vue?vue&type=script&lang=js&"
export * from "./DocumentsDisplayToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports